import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';
import { StyledContainer, StyledTitleContainer } from './ReferralInfo.styles';

export interface ReferralInfoProps {
  title: string | number;
  detail: string;
}

const ReferralInfo: React.FC<ReferralInfoProps> = ({ title, detail }) => {
  const theme = useTheme();
  return (
    <StyledContainer>
      <StyledTitleContainer>
        <Text
          variant='h5'
          fontWeight='fontWeightRegular'
          color={theme.palette.primary.main}
        >
          {title}
        </Text>
      </StyledTitleContainer>
      <Text
        variant='h5'
        fontWeight='fontWeightSemiBold'
        color={theme.palette.black.A100}
      >
        {detail}
      </Text>
    </StyledContainer>
  );
};

export default ReferralInfo;
